// Libs
import classNames from 'classnames/bind';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Box, CircularProgress, Stack } from '@mui/material';
// Components, Layouts, Pages
import { BaseTimeLineItem } from '~/components/module/activity';
// Others
import { IActivity } from '~/utils/interface/activity';
import useCheckScrollable from '~/utils/hooks/useCheckScrollable';
// Styles, images, icons
import styles from './BaseTimeLine.module.scss';

type Props = {
  data: IActivity[];
  onLoadMore: () => void;
  hasMore: boolean;
  loadMoreSize?: number;
  onView: (activity: IActivity) => void;
};

const cx = classNames.bind(styles);

const BaseTimeLine = (props: Props) => {
  //#region Destructuring Props
  const { data, hasMore, loadMoreSize = 14, onLoadMore, onView } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  useCheckScrollable({ containerId: 'mainContentSection', onNotScrollable: onLoadMore });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box id='baseTimelineComponent' className={cx('container')}>
      <InfiniteScroll
        dataLength={data.length}
        next={onLoadMore}
        hasMore={hasMore}
        loader={
          <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} height={35}>
            <CircularProgress size={loadMoreSize} />
          </Stack>
        }
        scrollableTarget={'mainContentSection'}
        scrollThreshold={0.6}
      >
        <BaseTimeLineItem activityData={data} onView={onView} />
      </InfiniteScroll>
    </Box>
  );
};

export default BaseTimeLine;
